import { Can, TooltipButton } from 'components';
import { EditOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useOpenDrawerHandler } from 'hooks';
import { Drawers } from 'app/types/drawer';
import { useSelector } from 'react-redux';
import { selectors } from 'app/services/projects';
import { User } from 'constants/index';
import { State } from 'constants/site';

const ManageCommentsButton = () => {
  const { t } = useTranslation();

  const project = useSelector(selectors.getProject);

  if (!project || project.State !== State.ACTIVE) return null;

  const handleClick = useOpenDrawerHandler({
    key: Drawers.MANAGE_PROJECT_COMMENTS,
    title: t('forms.projectcomments.title'),
    props: { projectId: project.Id } });

  return (
    <Can requiredPermission={User.Permissions.MANAGE_PROJECTS}>
      <TooltipButton
        title={t('common.managecomments')}
        buttonProps={{
          icon: <EditOutlined />,
          type: 'link',
          onClick: handleClick,
        }}
      />
    </Can>
  );
};

export default ManageCommentsButton;